var base = require('settings/teams/pending-invitations');

Vue.component('spark-pending-invitations', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/pending-invitations.js